export const jp = {
    Language: {
        english: "英語",
        japan: "日本語"
    },
    Menu: {
        home: "ホーム",
        dashboard: "ダッシュボード",
        territoryDefinition: "テリトリー定義管理",
        territoryAllocation: "テリトリー担当者管理",
        parentChildFacility: "親子紐付け施設管理",
        parentChildChange: "親子紐付け施設変更 状況照会",
        organizationCustomer: "アルトマーク施設照会・変更申請",
        personCustomer: "アルトマーク医師(薬剤師)照会・変更申請",
        newCustomerRequest: "新規顧客申請",
        customerRequestStatus: "申請状況照会",
        customer: "顧客",
        territory: "テリトリー",
        logout: "ログアウト",
        downloads: "ダウンロード"
    },
    territoryDefinitionMaintenance: {
        currentMonth: "当月",
        nextMonth: "翌月",
        system: "システム",
        applyToNext: "翌月にも反映",
        BU: "BU",
        division: "営業部門",
        branch: "支店・営業部",
        updatedBy: "更新者",
        lastUpdate: "最終データ更新日",
        salesOffice: "営業所",
        territorySetToMaintain: "メンテナンス対象テリトリー",
        totalRecords: "合計レコード数",
        territoryDefinitions: "テリトリー",
        blocks: "ブロック",
        facilitiesInSelectedBlock: "ブロック内施設",
        wwid: "WWID",        
        checked: " - 選択済み",
        parChecked: "一部選択済み",
        unChecked: " - 未選択"
    },
    territoryAllocationMaintenance: {
        territoryAllocations: "テリトリー担当者",
        employee: "担当者名 *",
        nonMREmployee: "MR以外の社員が割り当てられています。",
        otherSalesOfficeMR: "他の営業所のMRが割り当てられています。",
        employeeMessage: "システムご利用可能時間帯は8～12時、14時～17時、20時～23時となります。",
        employeeMessage2: "ただし、第4営業日は8～12時、14時～15時の間となります。"
    },
    parentChildFacilityMaintenance: {
        facilitySearch: "施設検索",
        mr: "担当者名",
        prefecture: "都道府県",
        city: "市区町村",
        code: "コード",
        name: "名称",
        type: "タイプ",
        noOfBeds: "病床数",
        product: "製品",
        parentFacility: "親施設",
        updatedBy: "更新者",
        approvedBy: "承認者",
        approvedOn: "承認日",
        published: "承認済み",
        underReview: "承認依頼中"
    },
    parentChildChangeRequest: {
        id:"申請ID",
        childFacility: "子施設",
        product: "製品",
        newParentFacility: "新親施設",
        currentParentFacility: "現親施設",
        status: "ステータス",
        submittedBy: "申請者",
        submittedAt: "申請月",
        reviewedBy: "承認者",
        reviewedAt: "承認(却下)日",
        comments: "コメント"
    },
    OrganizationMenu: {
        organizationInfo: "施設情報",
        affiliatedPersonnel: "勤務医師・薬剤師",
        childFacilities: "子施設",
        parentFacilities: "親施設",
        allocatedEmployees: "担当者",
        hospitalFunctions: "病院機能",
        prefectureFunctions: "都道府県医療機能",
        nursingInfo: "看護情報",
        kanjiFacilityName: "施設名(漢字)",
        kanaFacilityName: "施設名(ｶﾅ)",
        kanjiPharmacist: "管理薬剤師名(漢字)",
        kanaPharmacist: "管理薬剤師名(ｶﾅ)",
        integratedCustomerCode: "統合顧客コード/MDBコード",
        address: "住所",
        freeText: "住所（フリーテキスト）",
        moreConditions: "詳細条件",
        allocatedSalesOffice: "担当営業所",
        allocatedMR: "担当者名",
        tel: "TEL",
        classifications: "分類",
        speciality: "診療科目",
        sortOrder: "ソート順",
        byIntegratedCode: "統合顧客コード順",
        byName: "名前順",
        facilityName: "施設名",
        cutomerCode: "統合顧客コード/MDBコード",
        customerType: "顧客種別",
        facilityClassType: "施設階層区分",
        affiliatedCode: "所属組織の顧客コード",
        affiliatedName: "勤務施設",
        affiliatedDepartment: "所属部門"
    },
    PersonMenu: {
        personInfo: "医師・薬剤師情報",
        personCustomerDetails: "医師・薬剤師の詳細",
        personCustomerSearch: "医師・薬剤師照会",
        kanjiPersonName: "氏名(漢字)",
        kanaPersonName: "氏名(ｶﾅ)",
        speciality: "診療科目",
        facilityClassifications: "施設分類",
        graduatedUniversity: "卒業校",
        graduatedYear: "卒業年",
        registeredYear: "登録年",
        sortOrder: "ソート順",
        from : "自",
        to: "至",
        kanjiName: "氏名(漢字)",
        kanaName: "氏名(カナ)",
        gender: "性別",
        birthPlace: "出生地",
        birthDate: "生年月日",
        dentistAssociation: "医師/薬剤師/歯科医協会",
        ultmarcPharmacistFlag: "アルトマーク薬剤師フラグ"
    },
    organizationDetails: {
        organizationCustomerDetails: "施設詳細",
        noDM: "DM不可フラグ",
        organizationCustomerSearch: "施設検索",
        basicProfile: "基本情報",
        requesterName: "要求者名",
        submittedDate: "送信日",
        modifiedDate: "変更日",
        speciality: "診療科目",
        numberOfBeds: "病床数",
        medicalArea: "医療圏",
        maintenanceInfo: "ステータス／メンテナンス情報",
        orgCustomerChangeRequest: "施設変更申請",
        custNewChangeRequest: "顧客申請 新規／変更",
        confirmationLabel: "顧客申請 新規／変更(確認)",
        completedLabel: "顧客申請 新規／変更(完了)",
        submissionID: "申請ID",
        unifiedCustomerCode: "統合顧客コード/MDBコード",
        customerType: "顧客種別",
        managementBody: "経営体",
        postalCode: "郵便番号",
        suburb: "大字・通称",
        street: "通り",
        addressLine: "住所(地番以降)",
        kanjiAddressLine: "番地以降(漢字)",
        kanaAddressLine: "番地以降(ｶﾅ)",
        kanjiCustomerName: "顧客名(漢字)",
        kanaCustomerName: "顧客名(ｶﾅ)",
        customerName: "顧客名",
        representativePersonCode: "代表者コード",
        kanjiRepresentativePersonCode: "代表者コード(漢字)",
        kanaRepresentativePersonCode: "代表者コード(ｶﾅ)",
        kanaRepresentativePerson: "代表者氏名(ｶﾅ)",
        kanjiRepresentativePerson: "代表者氏名(漢字)",
        plannedOpenDate: "開業予定日",
        specialities: "診療科目",
        ultmarcRemark: "アルトマーク社への連絡欄",
        ultmarcRemarkNote: "※ここに記載された情報はもれなくアルトマーク社へ連絡されます（社内向けの連絡欄ではございませんのでご注意ください）",
        reapplicationAcceptanceCode: "アルトマーク再配布コード",
        plannedDeleteReason: "削除予定理由",
        affiliatedCode: "勤務先施設",
        affiliatedDepartment: "所属診療科",
        role: "役職",
        universityRole: "役職(大学)",
        hospitalOwner: "施設開設者",
        ultmarcFacilityType: "アルトマーク施設区分",
        managementBodyType: "経営体",
        ultmarcHospitalType: "アルトマーク病院種別",
        hundredBedsType: "100床区分",
        facilityFunctionType: "機能区分",
        facilityClassType: "階層区分",
        custNameLocal: "施設略称(漢字)",
        custNameLocalKana: "施設略称(ｶﾅ)",
        kanjiAddress: "住所(漢字)",
        kanaAddress: "住所(ｶﾅ)",
        facilityRepresentativePerson: "施設代表者",
        supervisingPharmacist: "管理薬剤師",
        maintenanceDate: "許可病床数メンテ年月",
        approvedBeds: "許可病床数",
        general: "一般",
        psychiatric: "精神",
        tuberculosis: "結核",
        infectiousDisease: "感染症",
        recuperation: "療養",
        other: "その他",
        total: "合計",
        secondMedicalArea: "2次医療圏",
        thirdMedicalArea: "3次医療圏",
        issuedDate: "公示年月日",
        psychiatricBeds: "精神科病床",
        tuberculosisBeds: "結核病床",
        infectiousDiseaseBeds: "感染症病床",
        standardBeds: "基準病床数",
        existingBeds: "既存病床数",
        infectiousBeds: "感染症病床",
        shortageBeds: "過不足病床数",
        date: "年月日",
        relatedUniversityCustomer: "関連大学親コード",
        nursingHomeCustomer: "特養医務室コード",
        drugStoreCustomer: "チェーン店本部コード",
        wholesalerCompany: "卸法人コード",
        plannedOpeningFlag: "開業予定フラグ",
        closedFlag: "休院フラグ",
        wardClosure: "病棟閉鎖",
        reexaminationType: "再審査区分",
        unknownAddress: "住所不明",
        closedYearMonth: "休・開業年月",
        duplicatedCustomer: "重複時相手先",
        pharmacistCorrespondenceCode: "薬剤師対応コード",
        ultmarcModifiedDate: "アルトマーク修正年月日",
        ultmarcModificationType: "アルトマーク修正区分",
        jobTitle: "役職",
        customerName: "氏名",
        customerType: "顧客種別",
        product: "製品",
        childFacility: "子施設",
        parentFacility: "親施設",
        manager: "所属長",
        value: "値",
        cancelledDate: "取消日",
        nursingType: "看護種別",
        numberOfWards: "病棟数",
        onDutyType: "開勤区分",
        doctorAssociation: "医師会",
        onDutyStartedYear: "開業年",
        universityJobTitle: "大学職位名",
        ultmarcPlannedDeleteReason: "アルトマーク削除予定理由",
        ultmarcRecordSuspensionType: "アルトマーク利用停止区分",
        ultmarcRecordSuspensionStartDate: "アルトマーク利用停止登録年月日",
        ultmarcRecordSuspensionEndDate: "アルトマーク利用停止解除年月日",
        ultmarcProcessedDate: "アルトマーク処理日",
        retirementDate: "退職情報受信日",
        flag: "フラグ",
        approvedDate: "承認/指定日",
        doubleCount: "ダブルカウント",
        employeeSearch: "担当MR検索",
        defaultAddressBlock: "デフォルト住所ブロック",
        overrideOrgCustomerBlock: "施設ブロック(上書き情報)",
        noticeLabel: "お知らせ"
    },
    personDetails: {
        personCustomerInfo: "個人情報",
        personCustomerChangeRequest: "個人顧客変更リクエスト",
        affiliatedFacilities: "勤務先施設",
        affiliatedFacilitiesHistory: "勤務先施設(履歴)"
    },
    customerRequestStatus: {
        searchCondition: "検索条件",
        submissionData: "申請データ",
        submissionType: "申請区分",
        customerType: "顧客種別",
        submittedAt: "申請月",
        submittedBy: "申請者",
        submissionStatus: "申請ステータス",
        submitted:"提出済み",
        item : "項目",
        submittedValue: "提出された価値",
        responseFromUltmarc: "アルトマークからの応答",
        affiliationRequestStatus: "申請状況照会(所属)",
        orgRequestStatus: "申請状況照会(施設)",
        personRequestStatus: "申請状況照会(医師・薬剤師)",
        sentToUltmarc: "Ultmarc送信済み",
        acceptedByUltmarc: "Ultmarc承認（後日反映）",
        rejectedByUltmarc: "Ultmarc却下（再申請不可）",
        onHoldByUltmarc: "Ultmarc返却（再申請可）",
        reflectedToCustomerMaster: "Ultmarc外顧客として反映済み",
        resubmitted:"再申請済み",
        cancelled: "キャンセル",
        new: "新規",
        organizationCustomer: "施設",
        personCustomer: "医師(薬剤師)"
    },
    Buttons: {
        apply: "適用",
        save: "保存",
        select: "選択",
        restore: "RESTORE",
        selectAll: "すべて選択",
        reset: "リセット",
        remove: "削除",
        close: "閉じる",
        submit: "申請",
        approve: "承認",
        reject: "却下",
        search: "検索",
        add: "追加",
        next: "次",
        previous: "戻る",
        back: "戻る",
        resubmit: "再申請",
        edit: "編集",
        withdraw: "取下げ",
        ok: "OK",
        cancel: "キャンセル",
        backToInquiry: "検索画面に戻る",
        requestAttributeChange: "属性変更申請",
        requestClosure: "廃院申請",
        requestAffiliationAttributeChange: "勤務先属性変更申請",
        requestRetirement: "勤務先退職申請",
        requestNewAffiliation: "新規勤務先申請",
        loadMore: "さらに表示"
    },
    SalesMenu: {
        salesReports: "セールスレポート",
        dailySellout: "日別納入実績明細表",
        dailySelloutCA: "日別納入実績明細表(CA)",
        monthlySellout: "月別納入実績明細表",
        monthlySelloutCA: "月別納入実績明細表(CA)",
        selloutRotationByFacility: "納入回転一覧表",
        selloutRotationByWholesaler: "納入回転一覧表(CA)",
        emailSetting: "実績メール配信登録"
    },
    dailySellout: {
        processingDate: "処理日",
        personInCharge: "担当者名",
        targetPersonName: "担当者名",
        wwidSpecify: "WWID指定",
        organizationName: "所属組織",
        targetPersonInCharge: "	対象担当者",
        selectPersonInCharge: "担当者選択",
        allSelection: "対象担当者 ALL選択",
        preliminaryReport: "速報",
        previousBusinessDay: "前営業日のみ",
        targetPeriod: "対象期間",
        product: "製品",
        productL: "商品L",
        marketAuthorizationL: "承認L",
        formL: "剤形L",
        formulationL: "規格L",
        packL: "包装L",
        cityAndCounty: "市区郡",
        productsNotInCharge: "担当外製品",
        include: "含む",
        facilityClassification: "施設区分",
        hundredFloorDivision: "100床区分",
        twoHundredFloorDivision: "200床区分",
        hundredBedClassification: "100床区分",
        twoHundredBedClassification: "200床区分",
        evaluationTargetClassification: "施設評価属性区分",
        functionClassification: "機能分類",
        promotionSharingClassification: "プロモーション共有分類",
        doubleCount: "ダブルカウント",
        copromotionFlag: "販社品",
        wholesaleCorporationSelection: "卸法人",
        actualDigestionName: "実消化親施設名",
        deliveredFacilityName: "納入施設名",
        deliveryFacilityName: "納入先施設名",
        childFacilityName: "子施設名",
        accountingMonth: "計上月",
        dueDate: "納入日",
        numberOfBoxes: "箱数",
        drugPrice: "薬価金額",
        wholesaleCorporationName: "卸法人名",
        wholesaleBranch: "卸支店名/卸支所課名",
        wholesaleBranchName: "卸支店",
        slipNumber: "伝票番号",
        transactionClassification: "取引区分",
        childFacilityHundredFloorDivision: "子施設100床区分",
        childFacilityFunctionClassification: "子施設機能区分",
        parentFacilityPromotionClassification: "親施設プロモーション分担区分",
        parentFacilityEvaluationClassification: "親施設評価対象区分",
        doubleCountClassification: "ダブルカウント区分",
        display: "表示",
        months: "月",
        fixedMonth: "固定月",
        fixedMonthJPYear: "月固定(JP年度)",
        fixedMonthWholesaleYear: "月固定(卸年度)",
        wholesalerGroup: "卸グループ",
        wholesalerOrganization: "卸組織",
        legalEntity: "法人",
        area: "地域",
        county: "郡",
        excelDownload: "Excelダウンロード",
        choice: "選択",
        list: "リスト",
        searchMembers: "メンバーを検索",
        affiliation: " 所　属",
        fixedMonth: "月固定",
        alertPeriod: "アラート期間",
        sortItems: "ソート項目",
        numericalItems: "数値項目",
        parentFacilityCode: "親施設コード",
        parentFacilityName: "親施設名",
        nonDeliveryPeriod: "未納入期間",
        receivedAndPaidQuantity: "受領および支払数量",
        jan: "1月",
        feb: "2月",
        march: "3月",
        april: "4月",
        may: "5月",
        june: "6月",
        july: "7月",
        august: "8月",
        sept: "9月",
        oct: "10月",
        nov: "11月",
        dec: "12月",
        wholesaler: "卸売業者",
        wholesaleCorporation: "卸法人",
        wholesaleManagementSalesDepartment: "卸統括営業部",
        wholesaleSalesDepartment: "卸営業部",
        wholesaleBranch: "卸支店",
        wholesaleBranchSection: "卸支所課",
        areaWholesaleParentFacility: "エリア（卸親施設）",
        productType: "製品種別",
        productInformation: "製品情報",
        salesCompanyProducts: "販社品",
        all: "全て",
        inHouse: "社内",
        otherCompany: "他社",
        currentYear: "当年度",
        lastYear: "前年度",
        yearBeforeLast: "一昨年",
        partitionAmount: "分割量",
        actualDeliveryAmount: "実際の配送金額",
        corporationName: "卸法人名/卸統括営業部名/卸営業部名/卸支店名/卸支所課名",
        employeeNumber: "社員番号",
        name: "名前",
        mailDeliveryTimezone: "メール配信時間帯",
        companyWide: "全社",
        salesDivision: "営業部門",
        district: "営業所",
        emailSettings: "メール設定",
        mailDeliveryOrgCode: "組織コード",
        mailDeliveryOrgName: "メール配信対象組織名",
        mailDelivery: "メール配信対象組織階層",
        modifiedDateTime: "修正日時",
        modifiedEmployee: "修正者",
        deliveryTimeRegistration: "配信時間登録",
        returnToMenu: "メニューに戻る",
        achievementEmail: "実績メール登録画面",
        selectFromList: "リストから選択",
        parentFaciltyname: "実消化親施設名",
        packageQuantities: "箱数",
        salesAmount: "薬価金額",
        deliveredFacilityHundredFloorDivision: "納入施設100床区分",
        deliveredFacilityHundredBedsClassification: "納入施設100床区分",
        salesAmountByWholesaler: "仕切金額",
        salesAmountByCustomer: "実納入金額",
        customerPurchasePriceRate: "納入価率",
        facilityType: "施設タイプ",
        districtName: "営業所名",
        breakTime: "速報の更新時間",
        breakingTime: "【速報の更新時間】",
        updateMessage: "※更新（売上伝票の受信）は、一日2回です。更新時間は以下となります。",
        timeOne: "9:30頃",
        timeTwo: "13:30頃",
        listOne: "アルフレッサ、メディセオ、東邦薬品、バイタルネット ほくやく、モロオ、鍋林、岩渕薬品、岡野薬品、ケーエスケー 富田薬品、宮崎温仙堂商店、琉薬",
        listTwo: "アルフレッサ、スズケン、スズケン岩手、サンキ、スズケン沖縄薬品、翔薬 ほくやく、モロオ、アスティス、ナカノ薬品、四国薬業、東七 武田薬品ＣｏＰｒｏ",
        masterAdmin: "マスタ管理",
        systemError: "システム停止中",
        systemErrorMessage: "ただ今、サービス稼働時間外です。ブラウザを閉じて、稼働時間内に再度ログインしてください。",
        maintenance: "メンテナンス",
        packageQuantity: "箱数",
        bulkQuantity: "受払数量",
        salesAmountByWholesalerPurchasePrice: "仕切金額",
        salesAmountByCustomerPurchasePrice: "実納入金額",
        year: "年度",
        hempLaw: "麻向法対象区分",
        janssenProduct: "自社",
        mainProduct: "他社",
        delete: "消去",
        salesOfficeName: "営業所名",
        employeeWwid: "WWID",
        unifiedCode: "親施設コード",
        unifiedName: "親施設名",
        loginName: "ログインユーザ名",
        selectSalesOffice: "メールを受信したい営業所を選択してください。",
        allSelectionConfirmation: "ALL選択がチェックされています。",
        run: "実行しますか？",
        timeConfirmation: "登録してよろしいですか？"
    },
    annotations: {
        personInChargeAnnotation: "対象製品の担当者をすべて選択したい場合、チェックを入れてください",
        targetPeriodAnnotation: "対象期間を選択して下さい。【速報の考え方】前営業日の伝票締め時間である20時以降に取り込まれた実績データを「速報」としていち早くご確認いただけます。9:30頃、13:30頃の2回、最新の状況に更新しています。詳細は",
        here: "こちら",
        information: "をクリックしてご確認ください。",
        products: "他のBU製品も含む明細を表示したい場合は、チェックを入れてください",
        jpDuration: "JP年度で当年、前年、前々年を３段表示します。",
        wholesaleDuration: "卸年度で当年、前年、前々年を３段表示します。",
        target: "対象期間を１段表示します。",
        mailMessage: "メール配信時間帯を変更すると、全社、BU、営業部門等、全てのメール配信時間が変更されます。",
        applyNotice: '検索条件を入力してください。'
    },
    errorMessages: {
        VALID_KANJI_FACILITY_NAME: "漢字名称を入力してください。",
        VALID_KANA_FACILITY_NAME: "半角ｶﾅで入力してください。",
        VALID_FACILITY_NAME: "施設名もしくは顧客コードを入力してください",
        PROVIDE_KANJI_FACILITY_NAME: "漢字名称を入力してください。",
        VALID_INTEGRATED_CODE: "統合顧客コードを入力してください。",
        VALID_ADDRESS: "有効な住所を入力してください。",
        VALID_NUMBER: "有効な電話番号を入力してください。",
        VALID_POSTAL_CODE: "有効な郵便番号を入力してくだい。",
        RESTORE_SUCCESS: "Restoreに成功しました",
        RESTORE_FAILED: "Restoreできませんでした",
        VALID_NAME: "有効な名前を入力してください。",
        PROVIDE_CUSTOMER_TYPE: "顧客種別を入力してください。",
        PROVIDE_PREFECTURE: "都道府県を選択してください。",
        PROVIDE_CITY: "市区町村を選択してください。",
        PROVIDE_SUBURB: "大字・町名を選択してください。",
        PROVIDE_STREET: "丁目を選択してください",
        VALID_POSTAL_CODE: "有効な郵便番号を入力してください。",
        PROVIDE_KANJI_ADDRESS: "漢字住所を入力してください。",
        VALID_KANJI_ADDRESS: "漢字住所を入力してください。",
        VALID_KANA_ADDRESS: "ｶﾅ住所を入力してください。",
        VALID_KANJI_REPRESENTATIVE: "漢字で入力してください。",
        VALID_KANA_REPRESENTATIVE: "半角ｶﾅで入力してください。",
        PROVIDE_NUMBER_OF_BEDS: "病床数を入力してください。",
        PROVIDE_SPECIALITY: "診療科目を1つ以上選択してください。",
        VALID_REMARKS: "有効な備考欄情報を入力してください。（改行不可）",
        VALID_KANJI_CUSTOMER_NAME: "漢字で入力してください。",
        VALID_KANA_CUSTOMER_NAME: "半角ｶﾅで入力してください。",
        REQUIRE_SPACE_BETWEEN_LAST_FIRST_NAME: "姓と名の間にはスペースを入れてください。",
        VALID_KANJI_PHARMACIST_NAME: "漢字で入力してください。",
        VALID_KANA_PHARMACIST_NAME: "半角ｶﾅで入力してください。",
        VALID_KANJI_PERSON_NAME: "漢字で入力してください。",
        VALID_KANA_PERSON_NAME: "半角ｶﾅで入力してください。",
        VALID_KANJI_NAME: "漢字で入力してください。",
        VALID_KANA_NAME: "半角ｶﾅで入力してください。",
        PROVIDE_KANJI_NAME: "漢字で入力してください。",
        PROVIDE_AFFILIATED_CUSTOMER_CODE: "勤務先の統合顧客コードを設定してください。",
        PROVIDE_NUMBER: "番号を入力してください。",
        VALID_KANJI_PHARMACIST: "漢字で入力してください。",
        VALID_KANA_PHARMACIST: "半角ｶﾅで入力してください。",
        PROVIDE_BU: "BU選択してください。",
        PROVIDE_DIVISION: "営業部門を選択してください。",
        PROVIDE_BRANCH: "支店・営業部を選択してくだい。",
        PROVIDE_SALES_OFFICE: "営業所を入力してください。",
        PROVIDE_TERRITORY: "メンテナンス対象テリトリーを選択してください。",
        PROVIDE_MR: "MRを選択してください。",
        PROVIDE_DURATION: "期間を選択してください。",
        
        CANCEL_REQUEST: "この申請をキャンセルしますか？",
        NOT_FOUND: "申請が見つかりません。",
        SEARCH_REQUESTS: "申請を照会する場合は、こちらのリンクをクリックしてください。",
        NO_DATA: "該当データなし。",
        REQUEST_NOT_SUBMITTED: "申請が登録できませんでした。再度試してください。",
        REQUEST_NOT_SUBMITTED_US_EXISTED:"DCR 要求が保存されていません。エラー: 顧客の所属は既に存在します",
        REQUEST_CANCELLED: "申請は取り消されました。",
        Login: "ログイン",
        SELECT_SALES_OFFICE: "メール受信したい営業所を選択してください。",
        REGISTER: "登録してよろしいですか？",
        WARNING_RESTORE: "このテリトリー定義を復元してもよろしいですか?",
        SAVE_SUCCESS: "登録しました。",
        PARENT_CHILD_RELATION: "親子紐付けは登録されました。",
        DUPLICATE_RECORD: "重複レコードが存在します。",
        CHANGE: "変更",
        PERSON_CUSTOMER: "医師(薬剤師)",
        NON_MR_EMPLOYEE: "MR外の社員が設定されています。",
        OTHER_SALES_OFFICE_MR: "他営業所のMRが設定されています。",
        NO_FACILITIES: "施設が見つかりません。",
        REQUEST_SUBMITTED: "申請を受け付けました。",
        YOUR_REQUEST: "申請 ID",
        CANCELLED: "は取り消されました。",

        CUSTOMER_NOT_FOUND: "該当レコードが見つかりません。",
        comment: "コメント",
        VIEW_SUBMISSION_STATUS: "申請状況の確認はこちらから",
        ultmarcRecordID: "アルトマークレコードID",
        ultmarcFacilityTypeOne: "アルトマーク施設区分(レベル1)",
        ultmarcFacilityTypeTwo: "アルトマーク施設区分(レベル2)",
        medicalSpecialityOne: "診療科目(レベル1)",
        AFFILIATION_EXISTS: "該当勤務先情報がすでに存在します。",
        change: "変更",
        closure: "廃院",
        DOCTOR_PHARMACIST_REQUIRED_FIELD: "医師及び院内薬剤師の新規申請については、卒業校、卒業年、登録年、生年月日のいずれかの入力が必須となります"

    }
}